import { render, staticRenderFns } from "./BudgetCreator.vue?vue&type=template&id=513e1a3a&scoped=true&"
import script from "./BudgetCreator.vue?vue&type=script&lang=js&"
export * from "./BudgetCreator.vue?vue&type=script&lang=js&"
import style0 from "./BudgetCreator.vue?vue&type=style&index=0&id=513e1a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e1a3a",
  null
  
)

export default component.exports